export const AUTH_FORM_SUCCESS = "AUTH_FORM_SUCCESS";
export const AUTH_FORM_FAIL = "AUTH_FORM_FAIL";
export const AUTH_ERROR = "AUTH_ERROR";
export const USER_IS_LOADED = "USER_IS_LOADED";
export const LOG_OUT = "LOG_OUT";
export const CHECK_PASSWORDS = "CHECK_PASSWORDS";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const CHAGE_USER_DATA_FAILED = "CHAGE_USER_DATA_FAILED";
export const CHANGE_PROFILE = "CHANGE_PROFILE";
export const GET_USERS = "GET_USERS";
export const SEARCH_BY_USERNAME = "SEARCH_BY_USERNAME";